// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".moduleCardSub{\n    font-size: 0.7rem;\n    color: #6c757d !important;\n}\n\n.shortBorder{\n    content: \"|\";\n    color:black;\n}", ""]);
// Exports
module.exports = exports;
